import React, {useEffect, useCallback} from "react";
import {Route, Switch, useParams, useRouteMatch} from "react-router-dom";
import {useBooleanFeatureFlag} from "ub-feature-flagging-react";
import RemoteComponent from "shared/Utils/RemoteComponent";
import {USE_NATIVE_CONTENT_COMPONENTS} from "shared/constants";

import {usePage} from "../../../PageProvider/PageContext";
import {WIDGET_PAGE} from "../../../PageProvider/PageTitles";
import {getenv} from "../../../../../util/getEnv";
import {ContentListPage} from "../../../Content/page/ContentListPage";

function BlogDetailPage() {
    const {id} = useParams();
    return <div>Blog {id}</div>;
}

const Blog = (props) => {
    const matcher = useRouteMatch();
    const {setPage} = usePage();
    const remoteScope = "blogRemoteEntry.js";
    const GATEWAY_URL = getenv("GATEWAY_URL");
    const API_URL = getenv("API_URL");
    const ASSETS_URL = getenv("ASSETS_URL");
    const CONTENT_FEDERATED_MODULES_APP_URL = getenv(
        // Change the key below to default to module being served locally
        // DO NOT COMMIT CHANGES TO THIS KEY
        "CONTENT_FEDERATED_MODULES_APP_URL",
        "http://localhost:8080",
    );
    const useNativeContentComponents = useBooleanFeatureFlag(
        USE_NATIVE_CONTENT_COMPONENTS.key,
        USE_NATIVE_CONTENT_COMPONENTS.value,
    );

    const setPageValue = useCallback(() => {
        setPage(WIDGET_PAGE.WIDGET_CONTENT);
    }, [setPage]);

    useEffect(setPageValue, []);

    if (useNativeContentComponents) {
        return (
            <Switch>
                {/* Render blog list page for /blog */}
                <Route
                    exact
                    path={`${matcher.path}`}
                    render={(renderProps) => <ContentListPage {...renderProps} />}
                />

                {/* Render blog detail page for /blog/post/:id */}
                <Route
                    exact
                    path={`${matcher.path}/post/:id`}
                    render={(renderProps) => <BlogDetailPage {...renderProps} />}
                />
            </Switch>
        );
    }
    return (
        <React.Fragment>
            <RemoteComponent
                url={`${CONTENT_FEDERATED_MODULES_APP_URL}/${remoteScope}`}
                remoteScope="blog_page_federation"
                remoteModule="./ProspectContent"
                nestedProps={{
                    ...props,
                    env: {
                        API_URL,
                        GATEWAY_URL,
                        ASSETS_URL,
                    },
                }}
            />
        </React.Fragment>
    );
};

export default Blog;
